export class TenantCandidateDto {
    tenantId: string;
    tenantSlug: string;
    displayName: string;
}
